export default __webpack_public_path__ + "img/img_3.bb88987e.png";